import CheckIcon from "@mui/icons-material/Check";
import {
    Button,
    DialogContent,
    Grid,
    IconButton,
    TextareaAutosize,
    Typography,
} from "@mui/material";
import GenericAlert from "common/components/GenericAlert/GenericAlert";
import GenericDialog from "common/components/GenericDialog/GenericDialog";
import { ApiService } from "common/services/ApiService";
import { useAuth } from "context/AuthContext";
import moment from "moment";
import { useEffect, useState } from "react";
import { ROLE_MAP } from "utils/constants";
import useStyles from "./styles";

const MAP_ALERTS = {
    question: "Pregunta enviada",
    answer: "Respuesta enviada",
    see: "Leido",
};

const QuestionAnswerForum = ({ studentActivity, updateData }) => {
    const { auth } = useAuth();
    const classes = useStyles();
    const [newQuestion, setNewQuestion] = useState("");
    const [questions, setQuestions] = useState([]);
    const [showNewResponseMap, setShowNewResponseMap] = useState({});
    const [answerNewResponseMap, setAnswerNewResponseMap] = useState({});
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogContentText, setDialogContentText] = useState("");
    const [dialogAction, setDialogAction] = useState(null);
    const [alertText, setAlertText] = useState("");
    const [severity, setSeverity] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [action, setAction] = useState("");

    useEffect(() => {
        if (studentActivity?.questions && studentActivity?.questions.length > 0) {
            setQuestions(studentActivity.questions);
            setShowNewResponseMap(studentActivity.questions.map((obj) => ({ [obj.id]: false })));
            const answers = { ...answerNewResponseMap };
            studentActivity.questions.forEach((obj) => {
                answers[obj.id] = "";
            });
            setAnswerNewResponseMap(answers);
        } else {
            setQuestions([]);
            setShowNewResponseMap({});
            setAnswerNewResponseMap({});
        }
    }, [studentActivity]);

    const confirmAction = (action, callback, content) => {
        setAction(action);
        setDialogContentText(content);
        setDialogAction(() => callback);
        setDialogOpen(true);
    };

    const executeAction = async () => {
        if (dialogAction) {
            try {
                await dialogAction();
                setAlertText(MAP_ALERTS[action]);
                setSeverity("success");
            } catch {
                setAlertText("Ocurrió un error, intente nuevamente!");
                setSeverity("error");
            }
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 1500);
        }
        setDialogOpen(false);
    };

    const saveQuestion = async () => {
        const data = {
            text: newQuestion,
            role_name: auth?.selectedRole?.name,
        };
        await ApiService.addQuestion(studentActivity.id, data);
        setNewQuestion("");
        updateData();
    };

    const seeQuestion = async (idQuestion) => {
        await ApiService.seeQuestion(idQuestion);
        updateData();
    };

    const saveAnswer = async (parent) => {
        const data = {
            text: answerNewResponseMap[parent],
            parent,
            role_name: auth?.selectedRole?.name,
            course: studentActivity?.course_activity?.course,
            establishment: auth?.selectedEstablishment?.id,
        };
        await ApiService.addAnswer(data);
        updateData();
    };

    return (
        <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }}>
            <Grid md={3} sx={{ position: "fixed", top: "40%", left: "45%" }}>
                {showAlert && <GenericAlert severity={severity} text={alertText} />}
            </Grid>
            <Grid item xs={12} md={8}>
                <h3>Nueva pregunta</h3>
                <TextareaAutosize
                    placeholder="Escribí tu pregunta acá"
                    value={newQuestion}
                    minRows={5}
                    style={{ width: "100%", padding: "15px" }}
                    onChange={(evt) => setNewQuestion(evt.target.value)}
                />
            </Grid>
            <Grid item xs={12} md={8} display={"flex"} justifyContent={"flex-end"}>
                <Button
                    disabled={newQuestion.length === 0}
                    variant="contained"
                    onClick={() =>
                        confirmAction("question", saveQuestion, "¿Deseas enviar esta pregunta?")
                    }
                >
                    Enviar
                </Button>
            </Grid>
            <Grid item xs={12} md={8}>
                <h3>Preguntas anteriores:</h3>
            </Grid>
            {questions.map((question) => (
                <Grid
                    container
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "65%",
                    }}
                    key={question.id}
                >
                    <Grid item xs={12} className={classes.questionAnswerBox}>
                        {question.text}
                        <Grid
                            item
                            mt={2}
                            xs={12}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <div>
                                <Typography variant="subtitle2">
                                    de{" "}
                                    <b>
                                        <u>{`${question?.user?.email}`}</u>
                                    </b>
                                </Typography>
                                <Typography variant="subtitle2">
                                    rol: <b>{ROLE_MAP[question?.role_name] || ""}</b>
                                    {" - "}
                                    {moment(question.created_at).format("DD/MM/YYYY HH:mm")}
                                </Typography>
                            </div>
                            <Grid item sx={{ display: "flex", justifyContent: "end" }}>
                                {question.has_notification && (
                                    <IconButton
                                        onClick={() =>
                                            confirmAction(
                                                "see",
                                                () => seeQuestion(question.id),
                                                "¿Marcar como leída?"
                                            )
                                        }
                                    >
                                        <CheckIcon></CheckIcon>
                                    </IconButton>
                                )}
                                <Button
                                    size="small"
                                    disabled={
                                        (JSON.parse(auth?.userId) === question?.user?.id &&
                                            auth?.selectedRole?.name === question?.role_name) ||
                                        false
                                    }
                                    onClick={() =>
                                        setShowNewResponseMap({
                                            ...showNewResponseMap,
                                            [question.id]: true,
                                        })
                                    }
                                >
                                    Responder
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    {question.childrens?.map((obj, i) => (
                        <Grid item xs={11} key={i} className={classes.questionAnswerBox}>
                            {obj.text}
                            <Grid
                                item
                                mt={2}
                                xs={12}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div>
                                    <Typography variant="subtitle2">
                                        de{" "}
                                        <b>
                                            <u>{`${obj?.user?.email}`}</u>
                                        </b>
                                    </Typography>
                                    <Typography variant="subtitle2">
                                        rol: <b>{ROLE_MAP[obj?.role_name] || ""}</b>
                                        {" - "}
                                        {moment(obj.created_at).format("DD/MM/YYYY HH:mm")}
                                    </Typography>
                                </div>
                                {obj.has_notification && (
                                    <Grid item sx={{ display: "flex", justifyContent: "end" }}>
                                        <IconButton
                                            onClick={() => {
                                                confirmAction(
                                                    "see",
                                                    () => seeQuestion(obj.id),
                                                    "¿Marcar como leída?"
                                                );
                                            }}
                                        >
                                            <CheckIcon></CheckIcon>
                                        </IconButton>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    ))}
                    <Grid
                        item
                        xs={11}
                        style={{
                            display: showNewResponseMap[question.id] ? "block" : "none",
                        }}
                        id={`new-response-parent-${question.id}`}
                    >
                        <Grid item>
                            <h3>Respuesta</h3>
                            <TextareaAutosize
                                placeholder="Escribí tu respuesta acá"
                                minRows={5}
                                style={{ width: "100%", padding: "15px" }}
                                value={answerNewResponseMap[question.id] || ""}
                                onChange={(evt) =>
                                    setAnswerNewResponseMap({
                                        ...answerNewResponseMap,
                                        [question.id]: evt.target.value,
                                    })
                                }
                            />
                        </Grid>
                        <Grid item display={"flex"} justifyContent={"flex-end"} gap={2}>
                            <Button
                                variant="contained"
                                onClick={() =>
                                    confirmAction(
                                        "answer",
                                        () => saveAnswer(question.id),
                                        "¿Deseas enviar esta respuesta?"
                                    )
                                }
                            >
                                Guardar
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() =>
                                    setShowNewResponseMap({
                                        ...showNewResponseMap,
                                        [question.id]: false,
                                    })
                                }
                            >
                                Descartar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            ))}
            <GenericDialog
                title="Confirmación"
                open={dialogOpen}
                setOpen={setDialogOpen}
                handleSave={executeAction}
                saveButtonText="Sí"
                mandatoryText={false}
            >
                <DialogContent>{dialogContentText}</DialogContent>
            </GenericDialog>
        </Grid>
    );
};

export default QuestionAnswerForum;
